module.exports = __webpack_public_path__ + "img/catD.a67827f3.svg";